import type1Character from 'assets/images/summary/first-look/character_baby_1.svg';
import type2Character from 'assets/images/summary/first-look/character_baby_2.svg';
import type3Character from 'assets/images/summary/first-look/character_baby_3.svg';
import type4Character from 'assets/images/summary/first-look/character_baby_4.svg';
import type5Character from 'assets/images/summary/first-look/character_baby_5.svg';
import type6Character from 'assets/images/summary/first-look/character_baby_6.svg';
import type7Character from 'assets/images/summary/first-look/character_baby_7.svg';
import type7VariationCharacter from 'assets/images/summary/first-look/character_baby_7_variation.svg';
import { GutTypeValue } from './gutTypes';

type BabyGutTypeKey =
  | '1a'
  | '1b'
  | '2a'
  | '2b'
  | '3a'
  | '3b'
  | '4a'
  | '4b'
  | '5a'
  | '5b'
  | '6a'
  | '6b'
  | '7a'
  | '7b';

const TYPE_1: GutTypeValue = {
  type: 'Type 1',
  characterImage: type1Character,
  shortDescription: 'The Ideal Baby Gut',
  longDescription:
    "This Bifidobacterium-dominated gut type supports immune development and key nutrients your baby needs to grow and thrive. It's the gold standard for baby gut health.",
};

const TYPE_2: GutTypeValue = {
  type: 'Type 2',
  characterImage: type2Character,
  shortDescription: 'The Foundation Builder',
  longDescription:
    "Rich in beneficial Bacteroidaceae that help lay a diverse foundation and prepare your baby's gut for the exciting world of first foods.",
};

const TYPE_3: GutTypeValue = {
  type: 'Type 3',
  characterImage: type3Character,
  shortDescription: 'The Instigator',
  longDescription:
    'Dominated by pro-inflammatory Enterobacteriaceae, this gut type is known to develop antibiotic resistance which is more concerning for premature babies than full-term healthy ones.',
};

const TYPE_4: GutTypeValue = {
  type: 'Type 4',
  characterImage: type4Character,
  shortDescription: 'The resisting rebel',
  longDescription:
    'The Enterococcus-dominated gut, while not ideal, is common after C-sections or antibiotic exposure. This type can signal that beneficial bacteria are still catching up.',
};

const TYPE_5: GutTypeValue = {
  type: 'Type 5',
  characterImage: type5Character,
  shortDescription: 'The Troublemaker',
  longDescription:
    'Having a Streptococcus-dominant gut type is not ideal for babies and is associated with higher risk of eczema.',
};

const TYPE_6: GutTypeValue = {
  type: 'Type 6',
  characterImage: type6Character,
  shortDescription: 'The Unwelcomed Guest',
  longDescription:
    'Having a Staphylococcus dominated gut is typical after a C-section delivery. While linked to higher infection risks, this will change quickly as Staphylococcus do not thrive in the gut.',
};

const TYPE_7: GutTypeValue = {
  type: 'Type 7',
  characterImage: type7Character,
  shortDescription: 'The Unexpected',
  longDescription:
    'A rare gut type rich in bacteria that we don’t normally see dominating a baby’s gut. It is usually linked with C-section deliveries.',
};

const TYPE_7_OVER_6_MONTHS: GutTypeValue = {
  type: 'Type 7',
  characterImage: type7VariationCharacter,
  shortDescription: 'The New Kids',
  longDescription:
    'A rare gut type rich in bacteria that we don’t normally see dominating a baby’s gut. If seen after the age of 6 months, this is a sign your baby’s microbiome is starting to diversify.',
};

export function getGutTypeLookupBaby(age: number) {
  const SIX_MONTHS = 6 * 30;
  const selected7Variation = age >= SIX_MONTHS ? TYPE_7_OVER_6_MONTHS : TYPE_7;

  return {
    '1a': TYPE_1,
    '1b': TYPE_1,
    '2a': TYPE_2,
    '2b': TYPE_2,
    '3a': TYPE_3,
    '3b': TYPE_3,
    '4a': TYPE_4,
    '4b': TYPE_4,
    '5a': TYPE_5,
    '5b': TYPE_5,
    '6a': TYPE_6,
    '6b': TYPE_6,
    '7a': selected7Variation,
    '7b': selected7Variation,
  } satisfies Record<BabyGutTypeKey, GutTypeValue>;
}
